<!-- Desktop -->
@if (!isMobile()) {
<div class="desktop-tabs">
  <mat-tab-group
    [selectedIndex]="selectedTabIndex()"
    (selectedIndexChange)="onTabChange($event)"
  >
    <mat-tab>
      <ng-template mat-tab-label>Tickets ({{ ticketsCount() }})</ng-template>
      <ng-template matTabContent>
        <br />
        <app-tickets></app-tickets>
      </ng-template>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>Users ({{ usersCount() }})</ng-template>
      <ng-template matTabContent>
        <br />
        <app-users></app-users>
      </ng-template>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>Settings</ng-template>
      <ng-template matTabContent>
        <br />
        <app-settings></app-settings>
      </ng-template>
    </mat-tab>

</mat-tab-group>

</div>
} @else {
<!-- Mobile -->

<mat-card class="mobile-links" style="padding: 16px">

  <button mat-flat-button class="btn-grey" routerLink="/tickets">
    @if(!loading()) {
    Tickets ({{ ticketsCount() }})
    } @else {
    <mat-spinner diameter="20" strokeWidth="3"></mat-spinner>
    }
  </button>

  <button mat-flat-button class="btn-grey" routerLink="/users">
    @if(!loading()) {
    Users ({{ usersCount() }})
    } @else {
    <mat-spinner diameter="20" strokeWidth="3"></mat-spinner>
    }
  </button>

  <button mat-flat-button class="btn-grey" routerLink="/settings">
    Settings
  </button>

</mat-card>
}